import { render, staticRenderFns } from "./ViewVacationSubmitted.vue?vue&type=template&id=fb77dce2&scoped=true&"
import script from "./ViewVacationSubmitted.vue?vue&type=script&lang=ts&"
export * from "./ViewVacationSubmitted.vue?vue&type=script&lang=ts&"
import style0 from "./ViewVacationSubmitted.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ViewVacationSubmitted.vue?vue&type=style&index=1&id=fb77dce2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb77dce2",
  null
  
)

component.options.__file = "ViewVacationSubmitted.vue"
export default component.exports